import { DateTime } from "luxon";

/**
 * The API uses both ISO timestamps and SQL ones with a space, and Luxon needs a different parser for each.
 */
const parse = (value: string) => {
	const iso = DateTime.fromISO(value, { setZone: true });

	return iso.isValid ? iso : DateTime.fromSQL(value, { setZone: true });
};

const DATE_PATTERN = /^\d{4}-\d{2}-\d{2}([T\s]|$)/;

/**
 * Whether a value is a date, with or without a time.
 */
export function isDateString(value?: string | number | null): value is string {
	return typeof value === "string" && DATE_PATTERN.test(value) && parse(value).isValid;
}

/**
 * Narrows a value to the date it falls on, dropping any time component.
 */
export function toIsoDate(value?: string | number | null): string | undefined {
	return isDateString(value) ? (parse(value).toISODate() ?? undefined) : undefined;
}
